import { color, media } from "@universityofmaryland/web-token-library";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
import { base } from "./base.js";
const classNamePrefix = "umd-layout-grid-border";
function composeBordered(options) {
  const { columns, theme = "light" } = options;
  let baseGrid;
  if (columns === 2) {
    baseGrid = base.two;
  } else if (columns === 3) {
    baseGrid = base.three;
  } else {
    baseGrid = base.four;
  }
  const borderColor = theme === "dark" ? color.gray.dark : color.gray.light;
  const borderBase = {
    border: `1px solid ${borderColor}`,
    borderBottom: `none`,
    [`@media (${media.queries.medium.max})`]: {
      gridGap: 0
    }
  };
  const childBorders = {
    "& > *": {
      borderBottom: `1px solid ${borderColor}`,
      borderRight: `1px solid ${borderColor}`
    }
  };
  let nthChildRules = {
    borderTop: `none`,
    borderRight: `none`
  };
  for (let i = 1; i <= columns; i++) {
    const selector = i === 1 ? "& > *:first-child" : `& > *:nth-child(${i})`;
    nthChildRules[selector] = {
      borderTop: `1px solid ${borderColor}`
    };
  }
  const isDark = theme === "dark";
  let className;
  let deprecatedAliases = [];
  if (columns === 2) {
    className = isDark ? `${classNamePrefix}-dark-two` : `${classNamePrefix}-two`;
    deprecatedAliases.push(isDark ? "umd-grid-border-dark" : "umd-grid-border");
  } else if (columns === 3) {
    className = isDark ? `${classNamePrefix}-dark-three` : `${classNamePrefix}-three`;
    deprecatedAliases.push(isDark ? "umd-grid-three-border-dark" : "umd-grid-three-border");
  } else {
    className = isDark ? `${classNamePrefix}-dark-four` : `${classNamePrefix}-four`;
    deprecatedAliases.push(isDark ? "umd-grid-four-border-dark" : "umd-grid-four-border");
  }
  return objectWithClassName({
    ...baseGrid,
    ...borderBase,
    ...childBorders,
    [`&:not(:has(> :last-child:nth-child(${columns})))`]: nthChildRules,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const columnsTwo = composeBordered({ columns: 2, theme: "light" });
const columnsThree = composeBordered({ columns: 3, theme: "light" });
const columnsFour = composeBordered({ columns: 4, theme: "light" });
const columnsTwoDark = composeBordered({ columns: 2, theme: "dark" });
const columnsThreeDark = composeBordered({ columns: 3, theme: "dark" });
const columnsFourDark = composeBordered({ columns: 4, theme: "dark" });
export {
  columnsFour,
  columnsFourDark,
  columnsThree,
  columnsThreeDark,
  columnsTwo,
  columnsTwoDark,
  composeBordered
};
//# sourceMappingURL=border.js.map
